import format from 'date-fns/format';
import { DateTime } from 'luxon';
import { useTranslation } from 'next-i18next';

import { useCountdown } from '../../../hooks/useCountdown';
import { isInNext24Hours, isInNextSixDays } from '../../../utils/product';

type Props = {
  date: Date;
  addDaysToHours?: boolean;
  uniqueDateFormat?: string;
  keyCountdownDate?: string;
  keyCountdownDays?: string;
  keyCountdownTime?: string;
  sixDaysGateway?: boolean;
};

const ProductDate: React.FC<Props> = ({
  addDaysToHours = false,
  date,
  keyCountdownDate,
  keyCountdownDays = 'countdown.days',
  keyCountdownTime = 'countdown.time',
  sixDaysGateway = true,
  uniqueDateFormat,
}) => {
  const { t } = useTranslation('product');
  const timeZone = DateTime.local().offsetNameShort;

  const dateStr = uniqueDateFormat
    ? format(date, uniqueDateFormat)
    : `${format(date, 'cccc, dd MMMM – HH:mm')} ${timeZone}`;

  const showCountDown = sixDaysGateway
    ? isInNextSixDays(date)
    : isInNext24Hours(date);

  return (
    <span title={dateStr}>
      {showCountDown ? (
        <ProductDateCountdown
          addDaysToHours={addDaysToHours}
          date={date}
          keyCountdownDays={keyCountdownDays}
          keyCountdownTime={keyCountdownTime}
        />
      ) : keyCountdownDate ? (
        t(keyCountdownDate, { date: dateStr })
      ) : (
        dateStr
      )}
    </span>
  );
};

export default ProductDate;

export const ProductDateCountdown: React.FC<Props> = ({
  addDaysToHours = false,
  date,
  keyCountdownDays = 'countdown.days',
  keyCountdownTime = 'countdown.time',
}) => {
  const { t } = useTranslation('product');
  const { destructuredDate } = useCountdown({
    addDaysToHours,
    date,
  });

  return isInNext24Hours(date)
    ? t(keyCountdownTime, destructuredDate)
    : t(keyCountdownDays, destructuredDate);
};
